import React from 'react';
import Dashboard from '../Dashboard/Dashboard';

const BookingList = () => {
    return (
        <div>
            <div>
                <Dashboard></Dashboard>
                <div className="d-flex justify-content-center align-items-center">
                    <h3 className="title-style mt-2 mb-5">Booking List</h3>
                </div>
                <div style={{width:'40'}} className="d-flex justify-content-center">

                </div>
            </div>
        </div>
    );
};

export default BookingList;